export default {
  'component.moovin.title': 'Eiendommer',
  'component.moovin.tablesearch': 'Søk etter oppdragsnr. eller addresse',
};
